import env from 'src/env';

const getMeasurementsPath = (jobId) => {
  return `${env.API_SERVER}/api/v2/jobs/${jobId}/measurements.pdf`;
};

export default {
  getMeasurementsPath,
};
